import { render, staticRenderFns } from "./TrainPadGameList.vue?vue&type=template&id=1168dca8&scoped=true&"
import script from "./TrainPadGameList.vue?vue&type=script&lang=js&"
export * from "./TrainPadGameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1168dca8",
  null
  
)

export default component.exports